// Vaste activiteiten met pauzes en de checklist bij een herinnering (0031, golf 2; docs/DESIGN.md
// §8.W2b en §8.W3c). Handgeschreven zoals weather.ts en gelijk aan de API
// (apps/api/src/routes/v1/app/activities.ts); openapi.contract.test.ts bewaakt elke aanroep.
const id = (value) => encodeURIComponent(value);
export function createActivityClient(t) {
    const get = (path) => t.request('GET', path);
    const post = (path, body = {}) => t.request('POST', path, body);
    const patch = (path, body) => t.request('PATCH', path, body);
    const put = (path, body) => t.request('PUT', path, body);
    const del = (path, body) => t.request('DELETE', path, body);
    return {
        pauses: () => get('/v1/app/activities/pauses'),
        createPause: (input) => post('/v1/app/activities/pauses', input),
        updatePause: (pauseId, input) => patch(`/v1/app/activities/pauses/${id(pauseId)}`, input),
        removePause: (pauseId, ifVersion) => del(`/v1/app/activities/pauses/${id(pauseId)}`, ifVersion === undefined ? undefined : { if_version: ifVersion }),
        fixed: (seriesId) => get(`/v1/app/activities/fixed/${id(seriesId)}`),
        setFixed: (seriesId, input) => put(`/v1/app/activities/fixed/${id(seriesId)}`, input),
    };
}
//# sourceMappingURL=activity.js.map